module.exports = __webpack_public_path__ + "static/media/extreme-balconies.adfb7ba7.png";